export const getSquaredSizes = (width: number) => {
  const half = width / 2;
  return {
    height: width,
    halfWidth: half,
    halfHeight: half,
  };
};
